import { render } from "./ComponentOffcanvas.vue?vue&type=template&id=dac786e8"
import script from "./ComponentOffcanvas.vue?vue&type=script&lang=js"
export * from "./ComponentOffcanvas.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__